import { render, staticRenderFns } from "./RES.vue?vue&type=template&id=ce75eba6&"
import script from "./RES.vue?vue&type=script&lang=js&"
export * from "./RES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce75eba6')) {
      api.createRecord('ce75eba6', component.options)
    } else {
      api.reload('ce75eba6', component.options)
    }
    module.hot.accept("./RES.vue?vue&type=template&id=ce75eba6&", function () {
      api.rerender('ce75eba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/RES.vue"
export default component.exports